export default __webpack_public_path__ + "static/media/timelineIcon.ccbb8dca.svg";